export enum ErrorType {
  NotFound = 'Not Found',
  Forbidden = 'Forbidden',
  BadRequest = 'Bad Request',
  // The /loader/ fetch was aborted by the client timeout (backend/upstream
  // stall) — surfaced as a retryable error, not a blank page.
  BackendTimeout = 'Backend Timeout',
  // The /loader/ fetch failed on the network layer (e.g. server unreachable).
  BackendNetwork = 'Backend Network',
}
